import React from "react";

import {PublicClientApplication} from "@azure/msal-browser";
import {BrowserRouter} from "react-router";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ApiProvider} from "@contexts/ApiContext";
import {GeneralProvider} from "@contexts/GeneralContext";
import {MsalProvider} from "@azure/msal-react";
import {AlertProvider} from "@contexts/AlertContext";
import {AppRoutes} from "@shared/appRoutes/AppRoutes.tsx";
import "dayjs/locale/pt-br";
import {MaterialProvider} from "@shared/MaterialProvider.tsx";
import dayjs from "dayjs";
import {ContextMenuProvider} from "@contexts/ContextMenu.tsx";
import {AuthProvider} from "@contexts/providers/AuthProvider.tsx";

export const MainProviders: React.FC<{ msalInstance: PublicClientApplication }> = ({msalInstance}) => {
    dayjs.locale('pt-br');
    return (
        <ApiProvider>
            <GeneralProvider>
                <MsalProvider instance={msalInstance}>
                    <BrowserRouter>
                        <MaterialProvider>
                            <AuthProvider>
                                <ContextMenuProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                                        <AlertProvider>
                                            <AppRoutes/>
                                        </AlertProvider>
                                    </LocalizationProvider>
                                </ContextMenuProvider>
                            </AuthProvider>
                        </MaterialProvider>
                    </BrowserRouter>
                </MsalProvider>
            </GeneralProvider>
        </ApiProvider>
    );
};